export const FORBO_MAIL_PROPERTY = "isforboeiconsmail";
export const FORBO_ICONS_API_BASE_URL = "https://apisvc.forbo-icons.co.uk";
